export default {
  init: () => {
    const embed = document.getElementById('footer-mailing-list')

    if (embed) {
      const targetNode = embed
      const config = { childList: true }

      const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const form = embed.querySelector('form')

            if (form) {
              const email = form.querySelector('#email_address_0')
              const submit = form.querySelector('[type="submit"]')

              if (email) {
                email.setAttribute('placeholder', 'Enter Your Email')
              }

              if (submit) {
                submit.textContent = 'Subscribe'
              }

              observer.disconnect()
            }
          }
        }
      }

      const observer = new MutationObserver(callback)

      observer.observe(targetNode, config)
    }
  },
}
